import { css } from '@emotion/react'

const styles = {
  wrapper: css`
    padding: 16px;
  `,
}

export default styles
